import { type LinkProps } from '@mui/material'
import React from 'react'

import { MUIExternalLink } from 'components/common/MUIExternalLink'
import { track } from 'track'

export const MUITrackedExternalLink: React.FC<
  {
    eventName?: string
    eventProperties?: Record<string, unknown>
  } & LinkProps
> = ({ eventName = 'ExternalLinkClicked', eventProperties, href, ...rest }) => {
  return (
    <MUIExternalLink
      href={href}
      onClick={() => {
        track(eventName, { ...eventProperties, link: href })
      }}
      {...rest}
    />
  )
}
